import PropTypes from 'prop-types';
import FieldTypes from '../../../enums/FieldTypes';
import InputField from '../../../v2/form/InputField';

function AutocompleteFieldWrapper(props) {
  const selectSuggestedValue = suggestion => props.fieldContainer
    .setFieldValue(props.definedField.name, suggestion);
  
  const getSuggestedValues = () => {
    if (!props.value) return props.definedField.predictions;
    
    const input = props.value.toLowerCase();
    const startsWith = prediction => prediction.toLowerCase().startsWith(input);
    const matchedSuggestions = props.definedField.predictions
      .filter(option => option.toLowerCase().includes(input));
    
    return matchedSuggestions.sort((a, b) => {
      if (startsWith(a) && !startsWith(b)) return -1;
      if (!startsWith(a) && startsWith(b)) return 1;
      return 0;
    });
  };

  return (
    <InputField
      disabled={props.disabled}
      fieldContainer={props.fieldContainer}
      legacyNames={props.legacyNames}
      fieldNamePrefix={props.fieldNamePrefix}
      value={props.value}
      definedField={props.definedField}
      placeholder={props.definedField.placeholder}
      predictions={getSuggestedValues()}
      onSelect={selectSuggestedValue}
      fieldType={FieldTypes.AUTOCOMPLETE}
      onBlur={props.onBlur}
      addressType={props.addressType}
    />
  );
}

AutocompleteFieldWrapper.defaultProps = {
  value: '',
  disabled: false,
  fieldNamePrefix: '',
};

AutocompleteFieldWrapper.propTypes = {
  definedField: PropTypes.object.isRequired,
  fieldContainer: PropTypes.object.isRequired,
  legacyNames: PropTypes.object.isRequired,
  addressType: PropTypes.oneOf(['delivery', 'billing']).isRequired,
  onBlur: PropTypes.func,
  
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  fieldNamePrefix: PropTypes.string,
};

export default AutocompleteFieldWrapper;
